<script setup>
const emit = defineEmits(['update:modelValue'])

defineOptions({
  inheritAttrs: false
})

const props = defineProps({
  modelValue: {
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  isRequired: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
    <div class="form-row tw-mb-8 md:tw-mb-4">
        <div class="checkbox tw-w-full tw-text-left">
            <input
                type="checkbox"
                :id="props.name"
                :name="props.name"
                :value="props.modelValue"
                @change="emit('update:modelValue', $event.target.checked)"
                class="tw-mr-2"
            >
            <label
                class="d-inline-flex tw-text-sm theme-text"
                :for="props.name"
                v-html="props.label"
            >
            </label>
        </div>
    </div>
</template>